import React from 'react'
import { useNavigate, Link } from "react-router-dom"
import { StyledFooter } from './Footer.style'
import "../assets/style/footer.css"

import Telegram from "../../../assets/icons/Telegram"
import Facebook from "../../../assets/icons/Facebook"
import Instagram from "../../../assets/icons/Instagram"
import Mail from "../../../assets/icons/Mail"
import Internet from "../../../assets/icons/Internet"
import Calling from "../../../assets/icons/Calling"


import Logo from "../../../assets/images/footer-logo.png"
import GooglePlay from '../assets/icons/GooglePlay'


export default function Footer() {
  const navigate = useNavigate()
  const toAbout = () => {
    navigate("/about")
    window.scroll(0, 0)
  }
  const toSupport = () => {
    navigate("/support")
    window.scroll(0, 0)
  }
  const toContact = () => {
    navigate("/contact")
    window.scroll(0, 0)
  }

  return (
    <StyledFooter className="footer">
      <div className='shadow'></div>
      <div className='container'>
        <div className='footer-main'>
          <div className='footer-logo'>
            <img src={Logo} alt="footer-logo" className='logo' />
            <p>Copyright © SFELDINC,
              2020, All rights reserved</p>
            <div className='social'>
              <a href={"https://t.me/sfeld_24"}><Telegram /></a>
              <a href="https://www.facebook.com/profile.php?id=100086904313574"> <Facebook /></a>
              <a href='https://www.instagram.com/sf_eld'><Instagram /></a>
            </div>
            <a target={"_blank"} href='https://play.google.com/store/apps/details?id=com.safeeld.mobile&hl=en&gl=US'>
              <GooglePlay />
            </a>
          </div>

          <div className='footer-info'>
            <div className='footer-list'>
              <h3>Company</h3>
              <ul className='footer-items'>
                <li className='footer-item' onClick={toContact}>
                  Contact us
                </li>
                <li className='footer-item' onClick={toSupport}>
                  Support login
                </li>
                {/* <li className='footer-item'>
                  <Link to={"/support"}>
                    Terms of Use
                  </Link>
                </li>
                <li className='footer-item'>
                  <Link to={"/about"}>
                    Privacy Policy
                  </Link>
                </li> */}
              </ul>
            </div>
            <div className='footer-list'>
              <h3>Resource</h3>
              <ul className='footer-items'>
                <li className='footer-item' onClick={toContact}>
                  Help Center
                </li>
                <li className='footer-item' onClick={toSupport}>
                  Manuals
                </li>
                <li className='footer-item' onClick={toSupport}>
                  Videos
                </li>
              </ul>
            </div>
            <div className='footer-list'>
              <h3>Contact</h3>
              <ul>
                <li className='footer-item'>
                  <Telegram />
                  <p>
                    <span>Telegram: </span>
                    <a href={"https://t.me/sfeld_24"}>@sfeld_24</a>
                  </p>
                </li>
                <li className='footer-item'>
                  <Mail />
                  <p>
                    <span>Email: </span>
                    <a href="https://mail.google.com/mail/u/0/#search/safeeldinc%40gmail.com" target="blank">
                      support@sfeldinc.com
                    </a>
                  </p>
                </li>
                <li className='footer-item'>
                  <Internet />
                  <p>
                    <span>Website: </span>
                    <a href={"https://www.sfeldinc.com"}>
                      www.sfeldinc.com
                    </a>
                  </p>
                </li>
                <li className='footer-item'>
                  <Calling />
                  <p>
                    <span>Phone number: </span>
                    <a href={"tel:+1(202) 9380805"}>
                      +1(202) 9380805
                    </a>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </StyledFooter>
  )
}

